import { t } from '@lingui/core/macro';
import Toggle from 'components/Toggle';
import { analyticsState } from 'state/analytics';
import { userSession } from 'state/session';

export const toggleCustomerControls = (value: boolean) => {
  userSession().setValues({ customerAllowance: value });
  analyticsState().setValues({ dealerToolUsed: 'customerAllowance' });
};

export default function CustomerAllowanceToggle() {
  const session = userSession().useState();

  return (
    <Toggle
      title={t`Enable customer model controls`}
      onSelect={toggleCustomerControls}
      value={session.customerAllowance}
    />
  );
}
